module.exports = __webpack_public_path__ + "static/media/personaltrainer.09191e7f.png";